import React from 'react';
import StackedChartContent from './StackedChartContent';
import YAxis from './YAxis';
import { LabelLeftRight } from './../../../common/chart/label';

const RecommendationHistory = () => (
  <div className="position-relative d-flex flex-fill flex-column">
    <div className="d-flex recommendation-history flex-fill">
      <YAxis />
      <StackedChartContent />
    </div>
    <LabelLeftRight
      text={'consensusAnalysis.recommendationHistoryTitle'}
      position={'left'}
    />
  </div>
);

export default RecommendationHistory;
